/**
 * Safe UUID v4 generator with fallback for non-HTTPS/older browsers.
 *
 * crypto.randomUUID() requires a secure context (HTTPS or localhost).
 * Falls back to Math.random-based UUID when unavailable.
 */
export function safeUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback: RFC 4122 v4 UUID with Math.random
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
